// @flow

import { authenticatedFetch } from '../../../api/request';

export function getOrgTeams(orgId: number) {
    return authenticatedFetch(`/v5/orgs/${orgId}/teams/all`);
}

export default {
    getOrgTeams
};
